import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import armyBookSlice from '@Redux/reducers/publication/army-book.slice';
import { ArmyBookActionState } from '@Stores/publication/army-book.state';

const BookActionComponent: React.FC<Props> = ({ toMake, toBuild }) => {
  return (
    <div className="army_list row">
      <div className="col-12 col-md-2 mt-1 text-center">
        <a href="#" onClick={() => toMake()}>
          <i className="fas fa-clipboard-list fa-2x" />
        </a>
        <a href="#" onClick={() => toBuild()} className="ms-1">
          <i className="fas fa-print fa-2x" />
        </a>
      </div>
    </div>
  );
};

const mapStateToProps = (_: AppState) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    toMake: () =>
      dispatch(
        armyBookSlice.actions.setRequestAction(ArmyBookActionState.Make),
      ),
    toBuild: () => dispatch(
      armyBookSlice.actions.setRequestAction(ArmyBookActionState.Print),
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BookActionComponent);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;
